import React, { useState, useEffect, useGlobal } from "reactn";
 
import Loader from "shared-anpost-components/components/loader/Loader";

import { SingleNotOwnedItemHistoryStyled } from "./SingleNotOwnedItemHistoryStyled";
import { CustomsStatusViewStyled } from "../../_core/customsChargesOverview/CustomsChargesViewStyled";
import { DeliveryItemOverviewStyled } from "../../_core/deliveryItemOverview/DeliveryItemOverviewStyled";
import { DeliveryHistoryTimelineStyled } from "../../_core/deliveryHistoryTimeline/DeliveryHistoryTimelineStyled";
import { CurrentStatusPillStyled } from "../../_common/currentStatusPill/CurrentStatusPillStyled";
import DeliveryTimelineItem from "../../_common/deliveryTimelineItem";
import { getItemSummary, getCustItemSummary, getEvents, checkDeliveredStatus } from "../../../services/Api";
import logoImage from "../../../images/defaultLogo.svg";
import Icon from "../../_common/icons/ReturnIcons";

const TRACKING_CODES = {
  customsChargePaid: 85,
  customsChargeRejected: 86,
  customsChargeExpired: 87,
  customsChargeRaised: 83,
  l5CustomerPreAdvice: 35
};

const SingleNotOwnedItemHistory = () => {
    const [notOwnedItemTrackingNumber, setNotOwnedItemTrackingNumber] = useGlobal("notOwnedItemTrackingNumber");
    const [countryOfOrigin, setCountryOfOrigin] = useState();
    const [traceCode, setTraceCode] = useState();
    const [statusDelivered, setStatusDelivered] = useState();
    const [events, setEvents] = useState([]);
    const [statusPillColour, setStatusPillColour] = useState();
    const [statusPillText, setStatusPillText] = useState();
    const [showCustomsContent, setShowCustomsContent] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const [loading, setLoading] = useState(false);
    const [permaExpand, setPermaExpand] = useState(true);

    useEffect(() => {
        window.dataLayer.push({
          event: "virtualPageView",
          pageview_url: `${window.location.pathname}/item-details`,
          pageview_title: `${document.title} - Item details`
        });
    }, [])

    useEffect(() => {
      // Get item summary
      const getItemSummaryData = {
        "getItemSummary": {
          "trackingItems": [
            notOwnedItemTrackingNumber
          ]
        }
      };

      const getItemSummaryFn = async data => {
        try {
            const res = await getItemSummary(data);

            // Function to convert text to title case
            const toTitleCase = (str) => {
              if (typeof str !== 'string') return str;
              return str
                .toLowerCase()
                .replace(/\b\w/g, (char) => char.toUpperCase());
            };

            if (res.data.getItemSummaryResponse.GetItemSummaryResult.length > 0) {
              setCountryOfOrigin(toTitleCase(res.data.getItemSummaryResponse.GetItemSummaryResult[0].countryOfOrigin));
              return
            }

            const custItemSummary = await getCustItemSummary({
                getCustItemSummary: {
                    customerNumbers: [notOwnedItemTrackingNumber]
                }
            });

            if (custItemSummary.data.getCustItemSummaryResponse.GetCustItemSummaryResult.length > 0) {
              setCountryOfOrigin(toTitleCase(custItemSummary.data.getCustItemSummaryResponse.GetCustItemSummaryResult[0].countryOfOrigin));
            }

        } catch (err) {
            console.log(err);
        }
      };
    
      getItemSummaryFn(getItemSummaryData);

      // Get events 
      const getEventsData = {
        "getEvents": {
          "barcodeItem": notOwnedItemTrackingNumber
        }
      }

      const getEventsFn = async data => {
        try {
          const res = await getEvents(data);

          setEvents(res.data.getEventsResponse.GetEventsResult);

          setTraceCode(res.data.getEventsResponse.GetEventsResult[0].traceCode);
        } catch (err) {
            console.log(err);
        }
      };

      getEventsFn(getEventsData);

      // Get delivery status
      const checkStatusDeliveredData = {
        "checkStatusDelivered": {
            "barcodeItem": notOwnedItemTrackingNumber
        }
      };

      const checkStatusDelivered = async data => {
        try {
          const res = await checkDeliveredStatus(data);

          setStatusDelivered(res.data.checkStatusDeliveredResponse.checkStatusDeliveredResult);
        } catch (err) {
            console.log(err);
        }
      };

      checkStatusDelivered(checkStatusDeliveredData);
    }, []);

    useEffect(() => {
      if (!events.length) return;

      const latestEventTraceCode = events[0].traceCode;

      // Note: https://anpost.atlassian.net/wiki/spaces/TTE/pages/3817406484/Status+Pill+for+Track+Trace+Items

      switch (latestEventTraceCode) {
        case 4:
        case 5:
        case 40:
        case 43:
        case 44:
        case 45:
        case 47:
        case 49:
        case 50:
        case 63:
        case 67:
        case 68:
        case 69:
        case 70:
        case 73:
        case 79:
          setStatusPillText("In transit");
          setStatusPillColour("#FF9C00");
          setShowCustomsContent(false);
          break;
        case 7:
        case 9:
        case 64:
        case 65:
        case 66:
        case 83:
        case 86:
        case 87:
          setStatusPillText("Customs");
          setStatusPillColour("#D22630");
          setShowCustomsContent(true);
          break;
        case 6:
        case 15:
        case 32:
        case 36:
        case 37:
        case 41:
        case 48:
          setStatusPillText("Item received");
          setStatusPillColour("#217BBE");
          setShowCustomsContent(false);
          break;
        case 1:
        case 8:
        case 19:
        case 46:
        case 51:
        case 52:
        case 57:
        case 78:
        case 85:
          setStatusPillText("Sorting");
          setStatusPillColour("#FF9C00");
          setShowCustomsContent(false);
          break;
        case 14:
        case 42:
          setStatusPillText("Delivered");
          setStatusPillColour("#00A76A");
          setShowCustomsContent(false);
          break;
        case 13:
        case 16:
          setStatusPillText("Delivery attempted");
          setStatusPillColour("#D22630");
          setShowCustomsContent(false);
          break;
        case 53:
        case 55:
        case 56:
        case 71:
        case 75:
        case 76:
        case 77:
          setStatusPillText("Return to sender");
          setStatusPillColour("#217BBE");
          setShowCustomsContent(false);
          break;
        default:
          setStatusPillColour("#217BBE");
          setStatusPillText("Info received");
          setShowCustomsContent(false);
      }
    }, [events]);

    // TODO - R2
    /* const deliveryConfirmation = async () => {
      const data = {
        "createDeliveryConfirmation": {
            "barcodeItem": notOwnedItemTrackingNumber,
            "emailAddr": "name@domain.com" // TODO - replace with user email from input
        }
      };
      try {
          const res = await axios.post(`${endpoint}/CreateDeliveryConfirmation`, data, {
            headers: {
              "Content-Type": "application/json",
              "Ocp-Apim-Subscription-Key": apiKey
            },
          });

          console.log("deliveryConfirmation res", res);

          // TODO - set state to show success message

          return res;
      } catch (err) {
          console.log(err);
      }
    }; */

    return (
        <SingleNotOwnedItemHistoryStyled>
            {loading && <Loader />}

            {notOwnedItemTrackingNumber && (
                <>
                    {/* LHS */}
                    <div className="cardWrapper">
                        <DeliveryItemOverviewStyled>
                            <div className="logoWrapper">
                                <img src={logoImage} alt="" aria-hidden="true" />
                            </div>

                            <div className="infoPanel">
                                <div className="contentWrapper">
                                    <p className="title">From: {countryOfOrigin}</p>
                                    <p className="content">{notOwnedItemTrackingNumber}</p>
                                </div>
                            </div>
                        </DeliveryItemOverviewStyled>

                        {/* // TODO - R2 */}
                        {/* {showCustomsContent && (
                          <>
                            // TODO - show success message based on state

                            // TODO - add expandable panel and form to collect email address

                            <button type="button" onClick={deliveryConfirmation}>Request confirmation</button>
                          </>
                        )} */}

                        {showCustomsContent && (
                            <>
                                <span className="textNotes">
                                    <b>Need help?</b>
                                    <br />
                                    Irish revenue have applied a customs charge to this An Post delivery. This must be paid within <b>16 working days</b>. An Post may apply a fee to handle, collect
                                    and process the item. Where applicable, this fee will be added to customs charges applied by the Revenue.
                                    <br />
                                    <a href={`${window.location.origin}/Post-Parcels/Receiving/Customs-Information`} target="_blank" rel="noreferrer" style={{ fontSize: "1.2rem", fontWeight: "700" }}>
                                        About Customs charges<span className="visually-hidden">(Opens in a new tab)</span>
                                    </a>
                                </span>
                            </>
                        )}

                        <span className="textNotes">
                            <b>Note:</b> This information is only for confirming delivery of parcels delivered by An Post. It is an offence under Section 53 of the Communications Regulation (Postal
                            Services) Act 2011 to use information obtained from a postal parcel for any other purpose.
                        </span>
                    </div>

                    {/* RHS */}
                    <div className="cardWrapper">
                        {traceCode === TRACKING_CODES.customsChargeRaised && (
                            <CustomsStatusViewStyled>
                                <div className="title">Customs charges</div>
                                <span className="description">You have pending customs charges</span>
                                <a
                                    href={`${window.location.origin}/Post-Parcels/Receiving/Pay-Customs-Charge?TrackingCode=${notOwnedItemTrackingNumber}`}
                                    className="bn bn--primary gtm-cta"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    View customs charges <span className="visually-hidden">(Opens in a new tab)</span>
                                </a>
                            </CustomsStatusViewStyled>
                        )}

                        <DeliveryHistoryTimelineStyled>
                            <div className="statusInfo">
                                <CurrentStatusPillStyled hasBackground selected={false} statusColor={statusPillColour}>
                                    {statusPillText}
                                    <span className="color"></span>
                                </CurrentStatusPillStyled>

                                {(!permaExpand && events) && events.length > 1 && (
                                    <button type="button" className="plusIconWrapper gtm-accordion" onClick={() => setIsExpanded(!isExpanded)} aria-expanded={isExpanded ? "true" : "false"}>
                                        <span className="visually-hidden">Toggle item details</span>
                                        <Icon src={isExpanded ? "minusIcon" : "plusIcon"} />
                                    </button>
                                )}
                            </div>

                            {events.length > 0 && (
                              <div>
                                 {events
                                    .filter((el, index) => (isExpanded || permaExpand ? el : index === 0))
                                    .map((item, index) => {
                                        return (
                                            <DeliveryTimelineItem
                                                key={index}
                                                isLastItem={
                                                    (isExpanded || permaExpand) &&
                                                    index === events.filter((el, index) => (isExpanded || permaExpand ? el : index === 0)).length - 1
                                                }
                                                status={item.activity}
                                                date={item.date}
                                                location={item.location}
                                                isCurrentStatus={index === 0}
                                            />
                                        );
                                    })}
                              </div>
                            )}
                        </DeliveryHistoryTimelineStyled>
                    </div>
                </>
            )}
        </SingleNotOwnedItemHistoryStyled>
    );
};

export default SingleNotOwnedItemHistory;
